/**
 * DONATION CONSTANTS
 * 
 * This file contains all constants for the Donation feature.
 * 
 * @module Donations/Constants
 */

import {
    DonationCurrency,
    DonationMethod,
    MobileMoneyProvider,
    DonationCategory,
    DonationStatus
} from '../types/donation.types';

// ============================================
// CURRENCY CONFIGURATION
// ============================================

export const CURRENCIES = [
    { value: DonationCurrency.ZMW, label: 'Zambian Kwacha (ZMW)', symbol: 'K' },
    { value: DonationCurrency.USD, label: 'US Dollar (USD)', symbol: '$' },
    { value: DonationCurrency.EUR, label: 'Euro (EUR)', symbol: '€' },
    { value: DonationCurrency.GBP, label: 'British Pound (GBP)', symbol: '£' },
    { value: DonationCurrency.CAD, label: 'Canadian Dollar (CAD)', symbol: 'C$' },
    { value: DonationCurrency.AUD, label: 'Australian Dollar (AUD)', symbol: 'A$' },
    { value: DonationCurrency.ZAR, label: 'South African Rand (ZAR)', symbol: 'R' }
];

// ============================================
// PAYMENT METHODS
// ============================================

export const PAYMENT_METHODS = [
    { value: DonationMethod.MOBILE_MONEY, label: 'Mobile Money' },
    { value: DonationMethod.BANK_TRANSFER, label: 'Bank Transfer' },
    { value: DonationMethod.CREDIT_CARD, label: 'Credit / Debit Card' },
    { value: DonationMethod.PAYPAL, label: 'PayPal' },
    { value: DonationMethod.STRIPE, label: 'Stripe' },
    { value: DonationMethod.CRYPTO, label: 'Cryptocurrency' }
];

// ============================================
// MOBILE MONEY PROVIDERS
// ============================================

export const MOBILE_PROVIDERS = [
    { value: MobileMoneyProvider.AIRTEL, label: 'Airtel Money', color: '#FF0000' },
    { value: MobileMoneyProvider.MTN, label: 'MTN Mobile Money', color: '#FFCC00' },
    { value: MobileMoneyProvider.ZEDMOBILE, label: 'ZedMobile', color: '#00A651' },
    { value: MobileMoneyProvider.ZAMTEL, label: 'Zamtel Money', color: '#ED1C24' }
];

// ============================================
// DONATION CATEGORIES
// ============================================

export const DONATION_CATEGORIES = [
    { value: DonationCategory.RADIO_PROGRAMS, label: 'Radio Programs' },
    { value: DonationCategory.RESEARCH, label: 'Research & Data' },
    { value: DonationCategory.GOVERNANCE, label: 'Governance & Accountability' },
    { value: DonationCategory.EDUCATION, label: 'Education' },
    { value: DonationCategory.HEALTH, label: 'Health' },
    { value: DonationCategory.EMERGENCY, label: 'Emergency Response' },
    { value: DonationCategory.GENERAL, label: 'General Fund' }
];

// ============================================
// STATUS CONFIGURATION
// ============================================

export const STATUS_CONFIG = {
    [DonationStatus.PENDING]: { label: 'Pending', color: '#F59E0B', bgColor: '#FFFBEB' },
    [DonationStatus.COMPLETED]: { label: 'Completed', color: '#10B981', bgColor: '#ECFDF5' },
    [DonationStatus.FAILED]: { label: 'Failed', color: '#EF4444', bgColor: '#FEF2F2' },
    [DonationStatus.REFUNDED]: { label: 'Refunded', color: '#6B7280', bgColor: '#F3F4F6' }
};

// ============================================
// DEFAULT VALUES
// ============================================

export const DEFAULT_DONATION_ALLOCATION = {
    radioPrograms: 25,
    research: 25,
    governance: 25,
    education: 0,
    health: 0,
    emergency: 0,
    general: 25
};

export const DEFAULT_DONATION = {
    donorName: '',
    donorEmail: '',
    donorPhone: '',
    amount: 0,
    currency: DonationCurrency.ZMW,
    method: DonationMethod.MOBILE_MONEY,
    mobileProvider: MobileMoneyProvider.AIRTEL,
    mobileNumber: '',
    category: DonationCategory.GENERAL,
    message: '',
    reference: '',
    isAnonymous: false,
    isRecurring: false,
    allocation: DEFAULT_DONATION_ALLOCATION
};